import { useMutation } from '@apollo/client';
import { gql } from '@apollo/client/core';

const UNARCHIVE_CLIENT = gql`
  mutation UnarchiveBuyer($accountUid: String!) {
    unarchiveBuyer(accountUid: $accountUid) {
      status
    }
  }
`;

export const useUnArchiveClient = () => {
  const [unArchiveClientMutation] = useMutation(UNARCHIVE_CLIENT); // Destructure error from useMutation

  const handleUnArchiveClient = async ({ accountUid }) => {
    try {
      const response = await unArchiveClientMutation({
        variables: {
          accountUid,
        },
      });

      return response;
    } catch (err) {
      console.error('Error :', err);
      // Handle the error appropriately (e.g., display a user-friendly message)
      return null; // Or throw a custom error for further handling
    }
  };

  return handleUnArchiveClient;
};
